<template>
    <v-data-table
        :value="value"
        :headers="headers"
        :items="items"
        :footer-props="footerProps"
        :page.sync="tablePage"
        :loading="tableLoading"
        class="b-outlined"
        :server-items-length="tableItemsLength"
        :disable-sort="sortBy?disableSort:true"
        :dense="dense"
        :group-by="groupBy"
        :group-desc="groupDesc"
        :hide-default-footer="hideDefaultFooter"
        :hide-default-header="hideDefaultHeader"
        :search="search"
        :options.sync="tableOptions"
        :item-class="itemClass"
        :item-key="itemKey"
        :item-style="itemStyle"
        :items-per-page="itemsPerPage"
        :no-data-text="noDataText"
        :no-result-text="noResultText"
        :selectable-key="selectableKey"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
    >
        <template v-slot:footer.page-text="{ pageStart,  pageStop }">
          <span v-if="tablePagination">  {{ pageStart }} - {{ pageStop }} <span v-if="tablePagination.total"> {{ translations.paginationText[lang] }} {{ tablePagination.total }}</span> </span>
        </template>
        <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
                <slot :name="`item.${header.value}`" :item="item">
                    {{ getValue(item, header.value) }}
                </slot>
        </template>
    </v-data-table>
</template>

<script>
import {
    mdiEmailOutline,
    mdiEmailMultipleOutline,
    mdiAlphabetical
} from "@mdi/js";
import translations from "@/utils/translations/global";
import { mapState } from "vuex";

export default {
    name: "BDataTable",

    mixins: [translations],

    props: {
        page: {
            type: [String, Number]
        },
        height: {
            type: [String, Number]
        },
        groupBy: {
            type: [String, Array]
        },
        groupDesc: {
            type: [Boolean, Array]
        },
        sortBy: {
            type: [String, Array]
        },
        sortDesc: {
            type: [Boolean, Array]
        },
        itemClass: {
            type: [String, Function]
        },
        itemStyle: {
            type: [String, Function]
        },
        footerProps: {
                default: () => ({
                itemsPerPageOptions: [12],
                showCurrentPage: true,
                disableItemsPerPage: true,
            })
        },
        pagination: {
            type: Object,
        },
        serverItemsLength: {
            type: [String, Number],
        },
        headers: Array,
        options: {
            type: Object,
        },
        items: {
            type: Array,
            default: () => []
        },
        value: Array,
        search: String,
        noDataText: String,
        noResultText: String,
        selectableKey: String,
        disableSort: {
            type: Boolean,
            default: false
        },
        hideDefaultFooter: {
            type: Boolean,
            default: false
        },
        hideDefaultHeader: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        itemKey: {
            type: String,
            default: 'id'
        },
        itemsPerPage: {
            type: Number,
            default: 12
        },
    },

    data: () => ({
        icons: {
            mdiEmailOutline,
            mdiEmailMultipleOutline,
            mdiAlphabetical
        },
        tablePage: 1,
        tableOptions: {}
    }),

    computed: {
        ...mapState([
            "serverPagination", 
        ]),
        lang() {
            return this.$route.params.lang;
        },
        tableLoading(){
            return this.loading || this.$store.state.loading
        },
        tablePagination () {
            return this.pagination ||  this.serverPagination 
        },
        tableItemsLength () {
            return  this.tablePagination?.total || ((this.tablePagination?.next_page || this.tablePagination?.current_page || 1) * Math.min(this.tablePagination.displayed,this.tablePagination?.items_per_page))
        },
    },
    
    watch: {
        page: {
            handler(val){
                this.tablePage = val
            }
        },
        tablePage: {
            handler(val){
                this.$emit('page-sync', val)
            }
        },
        tableOptions: {
            handler(val){
                this.$emit('options-sync', val)
            }
        }
    },
    methods: {
        addpage(){
            this.tablePage ++
        },
        getValue(item,val) {
            try {
                return eval(`item.${val}`)
            } catch (e) {
                console.error(e)
                return '-'
            }
        }
    }
};
</script>
